import React from 'react';
import useLivePrices from '../hooks/useLivePrices';
import './LivePrices.css';

const COIN_META = {
  BTCUSD: { name: 'Bitcoin',  emoji: '₿', color: '#f7931a' },
  ETHUSD: { name: 'Ethereum', emoji: 'Ξ', color: '#627eea' },
  SOLUSD: { name: 'Solana',   emoji: '◎', color: '#9945ff' },
  BNBUSD: { name: 'BNB',      emoji: 'B', color: '#f3ba2f' },
  XRPUSD: { name: 'XRP',      emoji: 'X', color: '#00aae4' },
};

const fmt = (n) =>
  n >= 1
    ? `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : `$${n.toFixed(4)}`;

const LivePrices = () => {
  const { prices, loading, error } = useLivePrices();

  return (
    <section className="live-prices-section section-padding">
      <div className="container">
        <div className="lp-header">
          <div className="tag"><span className="live-dot" /> Live — Delta Exchange</div>
          <h2 className="section-title">Real-Time Crypto <span className="gold-text">Prices</span></h2>
          <p className="section-subtitle">Live perpetual futures prices. Updated every 10 seconds.</p>
        </div>

        {loading && (
          <div className="lp-loading">
            <div className="lp-spinner" />
            <span>Fetching live prices…</span>
          </div>
        )}

        {error && !loading && <div className="lp-error">⚠️ {error}</div>}

        {!loading && !error && (
          <div className="lp-grid">
            {Object.values(prices).map((coin) => {
              const meta = COIN_META[coin.symbol] || {};
              const isUp = coin.changePct >= 0;
              return (
                <div className="lp-card card" key={coin.symbol}>
                  <div className="lp-card-top">
                    <div className="lp-icon" style={{ background: `${meta.color}22`, color: meta.color }}>
                      {meta.emoji}
                    </div>
                    <div>
                      <div className="lp-name">{meta.name}</div>
                      <div className="lp-sym">{coin.symbol} · Perp</div>
                    </div>
                    <div className={`lp-badge ${isUp ? 'up' : 'down'}`}>
                      {isUp ? '▲' : '▼'} {Math.abs(coin.changePct).toFixed(2)}%
                    </div>
                  </div>
                  <div className="lp-price">{fmt(coin.price)}</div>
                  <div className="lp-stats">
                    <div className="lp-stat">
                      <span className="lp-stat-label">24h High</span>
                      <span className="lp-stat-val up">{fmt(coin.high)}</span>
                    </div>
                    <div className="lp-stat">
                      <span className="lp-stat-label">24h Low</span>
                      <span className="lp-stat-val down">{fmt(coin.low)}</span>
                    </div>
                    <div className="lp-stat">
                      <span className="lp-stat-label">24h Change</span>
                      <span className={`lp-stat-val ${isUp ? 'up' : 'down'}`}>
                        {isUp ? '+' : ''}{coin.change.toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default LivePrices;